module.exports = __webpack_public_path__ + "assets/img/1_1729_big.ca90a949.jpg";